// ==============================|| HEADER CONTENT - MOBILE ||============================== //

const MobileSection = () => {
  return null;
};

export default MobileSection;
